import {extendTheme} from '@chakra-ui/react'
// Brand style Brand overrides
import styles from './foundations/styles'
import colors from './foundations/colors'
import gradients from '@salesforce/retail-react-app/app/theme/foundations/gradients'
import sizes from '@salesforce/retail-react-app/app/theme/foundations/sizes'
import space from '@salesforce/retail-react-app/app/theme/foundations/space'
import layerStyles from '@salesforce/retail-react-app/app/theme/foundations/layerStyles'
import shadows from '@salesforce/retail-react-app/app/theme/foundations/shadows'

import Input from './components/base/input'
import Radio from './components/base/radio'
import Button from './components/base/button'
import Checkbox from './components/base/checkbox'
import Container from './components/base/container'
import FormError from './components/base/formError'
// Base component style overrides
import Select from './components/base/select'
import Alert from '@salesforce/retail-react-app/app/theme/components/base/alert'
import Accordion from '@salesforce/retail-react-app/app/theme/components/base/accordion'
import Badge from '@salesforce/retail-react-app/app/theme/components/base/badge'
import Drawer from '@salesforce/retail-react-app/app/theme/components/base/drawer'
import FormLabel from '@salesforce/retail-react-app/app/theme/components/base/formLabel'
import Icon from '@salesforce/retail-react-app/app/theme/components/base/icon'
import Modal from '@salesforce/retail-react-app/app/theme/components/base/modal'
import Skeleton from '@salesforce/retail-react-app/app/theme/components/base/skeleton'
import Tooltip from '@salesforce/retail-react-app/app/theme/components/base/tooltip'
import Popover from '@salesforce/retail-react-app/app/theme/components/base/popover'

import CheckoutHeader from '../theme/components/project/checkout-header'
import CheckoutFooter from '../theme/components/project/checkout-footer'
import OrderSummary from '../theme/components/project/order-summary'
import PricePerItem from '../theme/components/project/price-per-item'
import formatPrice from '../theme/components/project/format-price'
import ItemPrice from '../theme/components/project/item-price'
import ItemName from '../theme/components/project/item-name'
import ItemImage from '../theme/components/project/item-image'
import ItemAttributes from '../theme/components/project/item-attributes'
import AddressFields from '../theme/components/project/address-field'
import shippingAddress from '../theme/components/project/shipping-address'
import payment from '../theme/components/project/payment'
import AddressDisplay from '../theme/components/project/address-display'
import shippingOptions from '../theme/components/project/shipping-options'
import confirmation from '../theme/components/project/confirmation'
import formFields from '../theme/components/project/form-fields'
import paymentForm from '../theme/components/project/paymentForm'

// Project Component style overrides
import App from '../theme/components/project/_app'
import Breadcrumb from '../theme/components/project/breadcrumb'
import Checkout from './components/project/checkout'
import Header from '@salesforce/retail-react-app/app/theme/components/project/header'
import ListMenu from '@salesforce/retail-react-app/app/theme/components/project/list-menu'
import Footer from '@salesforce/retail-react-app/app/theme/components/project/footer'
import LinksList from '@salesforce/retail-react-app/app/theme/components/project/links-list'
import DrawerMenu from '@salesforce/retail-react-app/app/theme/components/project/drawer-menu'
import NestedAccordion from '@salesforce/retail-react-app/app/theme/components/project/nested-accordion'
import LocaleSelector from '@salesforce/retail-react-app/app/theme/components/project/locale-selector'
import OfflineBanner from '@salesforce/retail-react-app/app/theme/components/project/offline-banner'
import Pagination from '@salesforce/retail-react-app/app/theme/components/project/pagination'
import ProductTile from '@salesforce/retail-react-app/app/theme/components/project/product-tile'
import SocialIcons from '@salesforce/retail-react-app/app/theme/components/project/social-icons'
import SwatchGroup from '@salesforce/retail-react-app/app/theme/components/project/swatch-group'
import ImageGallery from '@salesforce/retail-react-app/app/theme/components/project/image-gallery'
import PhoneDialCode from './components/project/phone-dial-code'
import Birthday from './components/project/birth-date'
import errorPage from './components/project/error-page'

export const overrides = {
    styles,
    layerStyles,
    colors,
    sizes,
    space,
    gradients,
    shadows,
    components: {
        Checkout,
        PhoneDialCode,
        CheckoutHeader,
        OrderSummary,
        AddressFields,
        AddressDisplay,
        shippingAddress,
        shippingOptions,
        confirmation,
        PricePerItem,
        formatPrice,
        ItemPrice,
        ItemName,
        ItemImage,
        ItemAttributes,
        Input,
        Accordion,
        Alert,
        Badge,
        Button,
        Checkbox,
        Container,
        Drawer,
        FormLabel,
        FormError,
        Icon,
        Modal,
        Popover,
        Radio,
        Select,
        Skeleton,
        Tooltip,
        App,
        Breadcrumb,
        Header,
        Footer,
        CheckoutFooter,
        LinksList,
        ListMenu,
        DrawerMenu,
        NestedAccordion,
        LocaleSelector,
        OfflineBanner,
        SocialIcons,
        Pagination,
        ProductTile,
        SwatchGroup,
        ImageGallery,
        formFields,
        Birthday,
        payment,
        paymentForm,
        errorPage
    }
}

export default extendTheme(overrides)
